import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Emails(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Рассылка
      </Typography.Title>
      <List />
    </div>
  );
}
